import React from "react";
import { NB_DocPlaceFormsModule_props } from "./type/docplace_forms_module.types";
import NbFormsModuleView from "./view/docplace_forms_module.view";

const NbFormsModule: React.FC<NB_DocPlaceFormsModule_props> = (props) => {
  return <NbFormsModuleView title={props.title} templates={props.templates} />;
};

export default NbFormsModule;
